export default defineNuxtPlugin({
    name: "zebline-script",
    parallel: false,
    order: 0,
    enforce: 'pre',
    setup() {
        const runtimeConfig = useRuntimeConfig();
        const zeblineToken = runtimeConfig.public.ZeblineToken as string;
        const zeblineLicenceCode = runtimeConfig.public.ZeblineLicenceCode as string;

        const initScript = document.createElement("script");
        initScript.id = "zebline-script";
        initScript.innerHTML = `
              (function () {
                  if (!window.zebline || typeof window.zebline.init !== "function") {
                      return;
                  }
                  window.zebline.init({
                      token: "${zeblineToken}",
                      licence_code: "${zeblineLicenceCode}",
                      notificationRequest: true,
                  });
              })();
        `;
        document.head.appendChild(initScript);
    },
});

export {};
